import { FormHeaderCheckbox } from 'components/shared/FormHeaderCheckbox/FormHeaderCheckbox';
import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addonManagementFormHeaderCheckboxToggle } from 'state/addonManagementForm/addonManagementForm.action';
import type { ProductGraph, ProductNode } from 'state/product-description/model';
import { areAllAddonManagementFormsSelected, isNoAddonManagementFormSelected } from 'state/selectors';

import { GridHeaderCell } from './GridUtils';

export interface AddonManagementFormTableHeaderProps {
  productDescription: ProductGraph;
  isUpfrontFeeColumnHidden: boolean;
  isOfferPriceColumnHidden: boolean;
  isFixedAmountInPercentColumnHidden: boolean;
  isTradingPriceColumnHidden: boolean;
}

export const AddonManagementFormTableHeader: FC<AddonManagementFormTableHeaderProps> = ({
  productDescription,
  isUpfrontFeeColumnHidden,
  isOfferPriceColumnHidden,
  isFixedAmountInPercentColumnHidden,
  isTradingPriceColumnHidden,
}) => {
  const dispatch = useDispatch();
  const isNoFormSelected = useSelector(isNoAddonManagementFormSelected);
  const areAllFormsSelected = useSelector(areAllAddonManagementFormsSelected);

  return (
    <>
      <GridHeaderCell
        className="is-sticky-top-left justify-content-center border-secondary fw-semibold border-bottom bg-lvl1"
        role="columnheader"
      >
        <FormHeaderCheckbox
          id="addon-management-select-all"
          e2e="addon-management-select-all"
          isNoFormSelected={isNoFormSelected}
          areAllFormsSelected={areAllFormsSelected}
          onToggle={() => dispatch(addonManagementFormHeaderCheckboxToggle())}
          hasCustomClass={false}
          margin="0 4px 0 0"
        />
      </GridHeaderCell>
      <GridHeaderCell
        className="is-sticky-top-left-2nd justify-content-center border-secondary fw-semibold border-bottom bg-lvl1"
        role="columnheader"
      >
        <FormattedMessage id="addon.Status" />
      </GridHeaderCell>
      {productDescription.map(blockNode =>
        blockNode.children?.map(
          fieldNode =>
            fieldNode.type !== 'Technical' &&
            (isShowDynamicColumn(fieldNode, 'UpfrontFee', isUpfrontFeeColumnHidden) ||
              isShowDynamicColumn(fieldNode, 'OfferPrice', isOfferPriceColumnHidden) ||
              isShowDynamicColumn(fieldNode, 'FixedAmountInPercent', isFixedAmountInPercentColumnHidden) ||
              isShowDynamicColumn(fieldNode, 'TradingPrice', isTradingPriceColumnHidden) ||
              isNotDynamicColumn(fieldNode)) && (
              <GridHeaderCell
                key={fieldNode.id}
                className="border-secondary fw-semibold border-bottom bg-lvl1 p-1"
                role="columnheader"
              >
                <FormattedMessage id={`addonManagement.field.${fieldNode.translationKey}` as any} />
              </GridHeaderCell>
            ),
        ),
      )}
    </>
  );
};

export function isShowDynamicColumn(node: ProductNode, id: string, hide: boolean) {
  return node.id === id && !hide;
}

export function isNotDynamicColumn(node: ProductNode) {
  return (
    node.id !== 'UpfrontFee' &&
    node.id !== 'OfferPrice' &&
    node.id !== 'FixedAmountInPercent' &&
    node.id !== 'TradingPrice'
  );
}
